/** Seeded PRNG (mulberry32) so a session's orientation/interleaving sequence is reproducible. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function randomSeed(): number {
  const a = new Uint32Array(1);
  crypto.getRandomValues(a);
  return a[0]!;
}

export function choice<T>(rng: () => number, items: readonly T[]): T {
  if (items.length === 0) throw new Error("choice from empty list");
  return items[Math.min(items.length - 1, Math.floor(rng() * items.length))]!;
}
